<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SelectMenu from 'dashboard/components-next/selectmenu/SelectMenu.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import CatalogProductSetFilterRow from './CatalogProductSetFilterRow.vue';

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
    // { logic: 'all'|'any', rules: [{ attribute, condition, value }] }
  },
  sources: {
    type: Array,
    default: () => [],
  },
});
const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();

const LOGIC_OPTIONS = computed(() => [
  { label: t('CATALOG.PRODUCT_SETS.FORM.LOGIC_ALL'), value: 'all' },
  { label: t('CATALOG.PRODUCT_SETS.FORM.LOGIC_ANY'), value: 'any' },
]);

const logicLabel = computed(
  () => LOGIC_OPTIONS.value.find(o => o.value === props.modelValue.logic)?.label || ''
);

const updateLogic = val => emit('update:modelValue', { ...props.modelValue, logic: val });

const updateRule = (index, rule) => {
  const rules = [...props.modelValue.rules];
  rules[index] = rule;
  emit('update:modelValue', { ...props.modelValue, rules });
};

const removeRule = index => {
  const rules = props.modelValue.rules.filter((_, i) => i !== index);
  emit('update:modelValue', { ...props.modelValue, rules });
};

const addRule = () => {
  const rules = [...props.modelValue.rules, { attribute: 'title', condition: 'contains', value: '' }];
  emit('update:modelValue', { ...props.modelValue, rules });
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex items-center gap-2 text-sm text-n-slate-11">
      <span>{{ t('CATALOG.PRODUCT_SETS.FORM.LOGIC_LABEL') }}</span>
      <SelectMenu
        :model-value="modelValue.logic"
        :options="LOGIC_OPTIONS"
        :label="logicLabel"
        sub-menu-position="bottom"
        @update:model-value="updateLogic"
      />
    </div>

    <div class="flex flex-col gap-2">
      <CatalogProductSetFilterRow
        v-for="(rule, index) in modelValue.rules"
        :key="index"
        :model-value="rule"
        :sources="sources"
        @update:model-value="updateRule(index, $event)"
        @remove="removeRule(index)"
      />
    </div>

    <Button
      icon="i-lucide-plus"
      color="slate"
      size="sm"
      variant="ghost"
      :label="t('CATALOG.PRODUCT_SETS.FORM.ADD_FILTER')"
      class="self-start"
      @click="addRule"
    />
  </div>
</template>
